import { ScrollView, StyleSheet, View } from 'react-native';
import React, { Component } from 'react';
import DateTile from './DateTile';
import { defaultScale } from '../../utils/scaling';
import moment from 'moment-timezone';

export default class DateTilesList extends Component {
  componentDidMount() {
    const currentSelectedIndex = this.props.dateList.find((singleDate) => {
      const isSelectedDay = moment(singleDate).isSame(
        moment(this.props.selectedDate.date),
        'day'
      );
      return isSelectedDay;
    });
    if (currentSelectedIndex) {
      const dateIndex = this.props.dateList.indexOf(currentSelectedIndex);
      setTimeout(() => {
        this.scrollToDateTile(dateIndex);
      }, 1);
    }
  }

  scrollToDateTile = (dateIndex) => {
    this.scroller.scrollTo({ y: dateIndex * 60 });
  };

  dateTileSelected = (newSelectedDate, dateIndex) => {
    this.scrollToDateTile(dateIndex);
    this.props.workoutDateTimeSelected(newSelectedDate);
  };

  render() {
    const { dateList, selectedDate } = this.props;
    return (
      <View style={styles.mainContainer}>
        <ScrollView
          ref={(scroller) => (this.scroller = scroller)}
          contentContainerStyle={styles.scrollViewContainer}
        >
          {dateList.map((singleDate, ind) => {
            return (
              <DateTile
                key={ind}
                date={singleDate}
                selectedDay={selectedDate}
                workoutDateTimeSelected={(item) =>
                  this.dateTileSelected(item, ind)
                }
              />
            );
          })}
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    width: '100%'
  },
  scrollViewContainer: {
    paddingBottom: defaultScale(60),
  },
});
